module.exports = __webpack_public_path__ + "static/media/Brunei Darussalam - BN.8be560c9.png";